// Determine the host of the system design depending on the environment
// Then put it to global window variable
window.__ADMINTOOL_DS__HOST__ = process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_REMOTE_MODE === 'local' 
        ? process.env.VUE_APP_ADMINTOOL_DS_LOCAL_HOST
        : process.env.VUE_APP_ADMINTOOL_DS_TEST_HOST
    : `${window.location.origin}/ds/`;
// Then import appication script
import('@/admintool');
